import React, { PropsWithChildren } from 'react'
import { AnalyticsElement } from '@typesApp/Analytics'
import { useAppTranslation } from '@hooks/useAppTranslation'
import { useEnvironment } from '@hooks/useEnvironment'
import { IconButtonLink } from '@components/foundation/icon-button/IconButton'
import { injectAnalytics } from '@utils/analyticsAttributes'
import { injectDataAttributes } from '@utils/dataAttributes'
import { openNewTab } from '@utils/openNewTab'
import styles from '../styles/ContactUsPanel.module.scss'

type ActionProps = {
  analyticsIndex: number
  noIcon?: boolean
  noPreLink?: boolean
} & PropsWithChildren

export const FAQAction: React.FC<ActionProps> = ({ analyticsIndex, noIcon, noPreLink, children }) => {
  const { faqUrl } = useEnvironment()
  const { t } = useAppTranslation()

  const onClick = () => {
    faqUrl && openNewTab(faqUrl)
  }

  return (
    <IconButtonLink
      onClick={onClick}
      underline
      iconProps={noIcon ? undefined : { library: 'base', name: 'faq' }}
      preLink={noPreLink ? undefined : t('ContactInfo.faq-prelink')}
      preLinkClassName={noPreLink ? undefined : styles.preLink}
      {...injectDataAttributes('contactUs.faq')}
      {...injectAnalytics(AnalyticsElement.MORE_INFO, { index: analyticsIndex })}
    >
      {!children && <span className={styles.linkText}>{t('ContactInfo.faq')}</span>}
      {children}
    </IconButtonLink>
  )
}
